/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardBase {
    getFixupPrototypeFunction() { return ComplianceStandardBase.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardBase>): ComplianceStandardBase {
        let obj = Object.assign(new ComplianceStandardBase(), model);
        ComplianceStandardBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardBase>): ComplianceStandardBase {
        if (!model) return null;
        return ComplianceStandardBase.newInstance(<ComplianceStandardBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardBase) {
        if (!obj) return;

        models.ComplianceStandardBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardBase): boolean {
        Object.setPrototypeOf(obj, ComplianceStandardBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the compliance standard
     */
    compliance_standard_name: string;

    /**
     * Scope of the compliance standard
     */
    scope: models.ComplianceStandardScope;

    /**
     * Description of the compliance standard
     */
    description: string;

    /**
     * Logo identifier for the standard
     */
    logo: string;

}
